import * as React from 'react'

export function Instagram(props: React.SVGProps<SVGSVGElement>) {
    return (
        <svg
            width="25"
            height="24"
            viewBox="0 0 25 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M12.623 6.958c-2.917 0-5.334 2.376-5.334 5.334a5.317 5.317 0 0 0 5.334 5.334c2.959 0 5.334-2.417 5.334-5.334S15.54 6.96 12.623 6.96zm0 8.751a3.432 3.432 0 0 1-3.417-3.417 3.432 3.432 0 0 1 3.417-3.417 3.432 3.432 0 0 1 3.417 3.417 3.432 3.432 0 0 1-3.417 3.417zm5.542-7.667a1.208 1.208 0 1 0 0-2.416 1.208 1.208 0 0 0 0 2.416z"
                fill="currentColor"
            />
            <path
                d="M21.29 3.708C20.207 2.583 18.665 2 16.915 2H8.331C4.706 2 2.289 4.417 2.289 8.042v8.542c0 1.792.583 3.334 1.75 4.46 1.125 1.083 2.625 1.624 4.334 1.624h8.5c1.792 0 3.292-.583 4.376-1.625 1.125-1.083 1.708-2.625 1.708-4.417V8.042c0-1.75-.583-3.25-1.667-4.334zm-.166 12.918c0 1.292-.459 2.334-1.209 3.042-.75.709-1.792 1.084-3.042 1.084h-8.5c-1.25 0-2.292-.375-3.042-1.084-.75-.75-1.125-1.792-1.125-3.084V8.042c0-1.25.375-2.292 1.125-3.042.708-.708 1.792-1.083 3.042-1.083h8.584c1.25 0 2.291.375 3.042 1.125.708.75 1.125 1.792 1.125 3v8.584z"
                fill="currentColor"
            />
        </svg>
    )
}
